import "./ChoiceButtons.scss";

import { useState } from "react";

import { Option } from "@types-runway/questionnaire";

interface ChoiceButtonsProps {
  options: Option[];
  onClick: (option: Option) => void;
}

const ChoiceButtons = ({ options, onClick }: ChoiceButtonsProps) => {
  const [activeButton, setActiveButton] = useState<string | null>(null);
  return (
    <div className="choice-buttons-wrapper">
      {options.map((option, i) => (
        <button
          data-testid={`choice-button-${i}`}
          className={`choice ${i === 0 ? "first" : i === options.length - 1 ? "last" : "middle"} ${
            activeButton === option.title ? "active" : ""
          }`}
          onClick={() => {
            onClick(option);
            setActiveButton(option.title);
          }}
        >
          {option.title}
        </button>
      ))}
    </div>
  );
};

export default ChoiceButtons;
